import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductServiceCategories', request)
}

async function post(request) {
    return await postMethod('/api/ownProductServiceCategories', request)
}

async function put(request) {
    return await putMethod('/api/ownProductServiceCategories', request)
}

export {get, post, put}
